import { useAssessmentsKeysQuery } from '@uplift/queries';
import sortBy from 'lodash/sortBy';
import React from 'react';


export const useAssessmentKeysList = () => {
  const { data: assessmentKeys } = useAssessmentsKeysQuery();

  return React.useMemo(() => {
    return sortBy(Object.entries(assessmentKeys), e => e[0].toLowerCase()).map(e => ({ key: e[0], formId: e[1] }));
  }, [ assessmentKeys ]);
};
